import axios from "axios";
import config from "../config";

export function createCourseCampaignClient(client) {
  client.interceptors.request.use((request) => {
    const token = localStorage.getItem("token");
    request.headers = { ...request.headers, ...(token ? { Authorization: `Bearer ${token}` } : {}) };
    return request;
  });
  return client;
}

export function createCourseCampaignService(client) {
  const endpoint = config.courseCampaignEndpoint;
  const options = (cancelToken, timeout = 15000) => ({ preventLoading: true, timeout, cancelToken });
  const unwrap = (response) => {
    if (!response.data.success) {
      const error = new Error("Campaign request failed");
      error.response = { data: response.data };
      throw error;
    }
    return response.data.data;
  };
  return {
    current: (cancelToken) => client.get(endpoint + "/current", options(cancelToken)).then(unwrap),
    submit: (id, payload, cancelToken) => client.post(endpoint + "/" + encodeURIComponent(id) + "/inquiries", payload, options(cancelToken, 45000)).then(unwrap)
  };
}

export const createCampaignCancellation = () => axios.CancelToken.source();
export default createCourseCampaignService(createCourseCampaignClient(axios.create()));
